/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseResVo
 */
export interface WarehouseResVo {
    /**
     * 主键ID
     * @type {number}
     * @memberof WarehouseResVo
     */
    id?: number;
    /**
     * 仓库类型 1=自营 2=代理
     * @type {number}
     * @memberof WarehouseResVo
     */
    warehouseType?: number;
    /**
     * 仓库类型名称（根据语言返回中文或韩文）
     * @type {string}
     * @memberof WarehouseResVo
     */
    warehouseTypeName?: string;
    /**
     * 仓库名称（韩文原始值，表单回显用）
     * @type {string}
     * @memberof WarehouseResVo
     */
    name?: string;
    /**
     * 仓库中文名称（中文原始值，表单回显用）
     * @type {string}
     * @memberof WarehouseResVo
     */
    nameCn?: string;
    /**
     * 仓库展示名称（根据语言返回中文或韩文，列表展示用）
     * @type {string}
     * @memberof WarehouseResVo
     */
    displayName?: string;
    /**
     * 国家ID
     * @type {number}
     * @memberof WarehouseResVo
     */
    nationId?: number;
    /**
     * 国家名称（根据语言返回）
     * @type {string}
     * @memberof WarehouseResVo
     */
    nationName?: string;
    /**
     * 仓库编码
     * @type {string}
     * @memberof WarehouseResVo
     */
    code?: string;
    /**
     * 代理编号
     * @type {string}
     * @memberof WarehouseResVo
     */
    warehouseProxyCode?: string;
    /**
     * 纸箱唛头号前缀
     * @type {string}
     * @memberof WarehouseResVo
     */
    boxMarknoPrefix?: string;
    /**
     * 托盘唛头号前缀
     * @type {string}
     * @memberof WarehouseResVo
     */
    palletMarknoPrefix?: string;
    /**
     * 邮政编码
     * @type {string}
     * @memberof WarehouseResVo
     */
    zip?: string;
    /**
     * 关联海外仓ID
     * @type {number}
     * @memberof WarehouseResVo
     */
    connectWarehouseId?: number;
    /**
     * 城市
     * @type {string}
     * @memberof WarehouseResVo
     */
    city?: string;
    /**
     * 省/州
     * @type {string}
     * @memberof WarehouseResVo
     */
    state?: string;
    /**
     * 地址
     * @type {string}
     * @memberof WarehouseResVo
     */
    address?: string;
    /**
     * 详细地址
     * @type {string}
     * @memberof WarehouseResVo
     */
    addressDetail?: string;
    /**
     * 地址（英文）
     * @type {string}
     * @memberof WarehouseResVo
     */
    addressEn?: string;
    /**
     * 详细地址（英文）
     * @type {string}
     * @memberof WarehouseResVo
     */
    addressDetailEn?: string;
    /**
     * 联系方式
     * @type {string}
     * @memberof WarehouseResVo
     */
    mobileNo?: string;
    /**
     * 联系人姓名
     * @type {string}
     * @memberof WarehouseResVo
     */
    contactName?: string;
    /**
     * 排序
     * @type {number}
     * @memberof WarehouseResVo
     */
    sort?: number;
    /**
     * 图片URL
     * @type {string}
     * @memberof WarehouseResVo
     */
    imageUrl?: string;
    /**
     * 状态 0=禁用 1=启用
     * @type {number}
     * @memberof WarehouseResVo
     */
    enable?: number;
    /**
     * 入库方式列表 1=快递 2=唛头 3=入库证
     * @type {Array<number>}
     * @memberof WarehouseResVo
     */
    receivingMethod?: Array<number>;
    /**
     * COUPANG中转 0=否 1=是
     * @type {number}
     * @memberof WarehouseResVo
     */
    transshipment?: number;
    /**
     * 3PL功能列表 1=仓储 2=一件代发
     * @type {Array<number>}
     * @memberof WarehouseResVo
     */
    warehouseFunction?: Array<number>;
    /**
     * 一件代发预支费用（韩币）
     * @type {number}
     * @memberof WarehouseResVo
     */
    dropshippingFee?: number;
    /**
     * 免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseResVo
     */
    freeStorageDays?: number;
    /**
     * 橙火订单免仓储费时限（天）
     * @type {number}
     * @memberof WarehouseResVo
     */
    rocketOrderFreeStorageDays?: number;
    /**
     * 仓储费单价（1CBM/1Day，韩币）
     * @type {number}
     * @memberof WarehouseResVo
     */
    storageFeeUnit?: number;
    /**
     * 纸箱卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseResVo
     */
    boxUnloadingFeeUnit?: number;
    /**
     * 托盘卸货费单价（韩币）
     * @type {number}
     * @memberof WarehouseResVo
     */
    palletUnloadingFeeUnit?: number;
    /**
     * 支持的运输方式ID列表
     * @type {Array<number>}
     * @memberof WarehouseResVo
     */
    transportMethodIds?: Array<number>;
    /**
     * 创建时间
     * @type {string}
     * @memberof WarehouseResVo
     */
    createTime?: string;
    /**
     * 更新时间
     * @type {string}
     * @memberof WarehouseResVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the WarehouseResVo interface.
 */
export function instanceOfWarehouseResVo(value: object): value is WarehouseResVo {
    return true;
}

export function WarehouseResVoFromJSON(json: any): WarehouseResVo {
    return WarehouseResVoFromJSONTyped(json, false);
}

export function WarehouseResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'warehouseType': json['warehouseType'] == null ? undefined : json['warehouseType'],
        'warehouseTypeName': json['warehouseTypeName'] == null ? undefined : json['warehouseTypeName'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameCn': json['nameCn'] == null ? undefined : json['nameCn'],
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'nationId': json['nationId'] == null ? undefined : json['nationId'],
        'nationName': json['nationName'] == null ? undefined : json['nationName'],
        'code': json['code'] == null ? undefined : json['code'],
        'warehouseProxyCode': json['warehouseProxyCode'] == null ? undefined : json['warehouseProxyCode'],
        'boxMarknoPrefix': json['boxMarknoPrefix'] == null ? undefined : json['boxMarknoPrefix'],
        'palletMarknoPrefix': json['palletMarknoPrefix'] == null ? undefined : json['palletMarknoPrefix'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'connectWarehouseId': json['connectWarehouseId'] == null ? undefined : json['connectWarehouseId'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'address': json['address'] == null ? undefined : json['address'],
        'addressDetail': json['addressDetail'] == null ? undefined : json['addressDetail'],
        'addressEn': json['addressEn'] == null ? undefined : json['addressEn'],
        'addressDetailEn': json['addressDetailEn'] == null ? undefined : json['addressDetailEn'],
        'mobileNo': json['mobileNo'] == null ? undefined : json['mobileNo'],
        'contactName': json['contactName'] == null ? undefined : json['contactName'],
        'sort': json['sort'] == null ? undefined : json['sort'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'receivingMethod': json['receivingMethod'] == null ? undefined : json['receivingMethod'],
        'transshipment': json['transshipment'] == null ? undefined : json['transshipment'],
        'warehouseFunction': json['warehouseFunction'] == null ? undefined : json['warehouseFunction'],
        'dropshippingFee': json['dropshippingFee'] == null ? undefined : json['dropshippingFee'],
        'freeStorageDays': json['freeStorageDays'] == null ? undefined : json['freeStorageDays'],
        'rocketOrderFreeStorageDays': json['rocketOrderFreeStorageDays'] == null ? undefined : json['rocketOrderFreeStorageDays'],
        'storageFeeUnit': json['storageFeeUnit'] == null ? undefined : json['storageFeeUnit'],
        'boxUnloadingFeeUnit': json['boxUnloadingFeeUnit'] == null ? undefined : json['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': json['palletUnloadingFeeUnit'] == null ? undefined : json['palletUnloadingFeeUnit'],
        'transportMethodIds': json['transportMethodIds'] == null ? undefined : json['transportMethodIds'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function WarehouseResVoToJSON(json: any): WarehouseResVo {
    return WarehouseResVoToJSONTyped(json, false);
}

export function WarehouseResVoToJSONTyped(value?: WarehouseResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'warehouseType': value['warehouseType'],
        'warehouseTypeName': value['warehouseTypeName'],
        'name': value['name'],
        'nameCn': value['nameCn'],
        'displayName': value['displayName'],
        'nationId': value['nationId'],
        'nationName': value['nationName'],
        'code': value['code'],
        'warehouseProxyCode': value['warehouseProxyCode'],
        'boxMarknoPrefix': value['boxMarknoPrefix'],
        'palletMarknoPrefix': value['palletMarknoPrefix'],
        'zip': value['zip'],
        'connectWarehouseId': value['connectWarehouseId'],
        'city': value['city'],
        'state': value['state'],
        'address': value['address'],
        'addressDetail': value['addressDetail'],
        'addressEn': value['addressEn'],
        'addressDetailEn': value['addressDetailEn'],
        'mobileNo': value['mobileNo'],
        'contactName': value['contactName'],
        'sort': value['sort'],
        'imageUrl': value['imageUrl'],
        'enable': value['enable'],
        'receivingMethod': value['receivingMethod'],
        'transshipment': value['transshipment'],
        'warehouseFunction': value['warehouseFunction'],
        'dropshippingFee': value['dropshippingFee'],
        'freeStorageDays': value['freeStorageDays'],
        'rocketOrderFreeStorageDays': value['rocketOrderFreeStorageDays'],
        'storageFeeUnit': value['storageFeeUnit'],
        'boxUnloadingFeeUnit': value['boxUnloadingFeeUnit'],
        'palletUnloadingFeeUnit': value['palletUnloadingFeeUnit'],
        'transportMethodIds': value['transportMethodIds'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

